
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#8d98aa","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/frame"}},[_c('path',{attrs:{"d":"M15.068 8.125c3.3.285 4.645 1.985 4.645 5.706v.119c0 4.107-1.64 5.752-5.735 5.752H8.014c-4.095.001-5.735-1.644-5.735-5.751v-.12c0-3.694 1.328-5.394 4.571-5.697"}}),_c('g',{attrs:{"data-name":"Group 654","opacity":".4"}},[_c('path',{attrs:{"data-name":"Vector","d":"M11 1.838v11.835M14.078 11.624L11 14.702l-3.078-3.078"}})])])])
          )
        }
      }
    